export default __webpack_public_path__ + "static/blob9-c7a692f43c8c5599767a5ae99a4fb89a.svg";